var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['tooltip', _vm.position]},[_vm._t("default"),_c('span',{staticClass:"tooltip-text"},[_vm._t("content")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }